import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/components/AppHeader';
import { Sidebar } from '@/components/shell/Sidebar';
import { BottomNav } from '@/components/BottomNav';
import { useEagerPrefetch } from '@/api/hooks';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { ClientScopeProvider } from '@/contexts/ClientScopeContext';
import { PreferenceEffects } from '@/components/shell/PreferenceEffects';
import { TooltipProvider } from '@/components/ui/tooltip';

export default function App() {
  useEagerPrefetch();

  return (
    <NotificationProvider>
      <ClientScopeProvider>
      <TooltipProvider delayDuration={300}>
        <PreferenceEffects/>
        <div className="flex h-full flex-col bg-background-muted">
          <AppHeader/>
          {/* Header (3.5rem) on top; sidebar + page below. Pages that size to the viewport allow for the header only. */}
          <div className="flex min-h-0 flex-1">
            <Sidebar/>
            <main className="min-w-0 flex-1 overflow-auto pb-16 md:pb-0">
              <Outlet/>
            </main>
          </div>
          <BottomNav/>
        </div>
      </TooltipProvider>
      </ClientScopeProvider>
    </NotificationProvider>
  );
}
